<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>课程管理</el-breadcrumb-item>
            <el-breadcrumb-item>课程列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <!-- 查询框 -->
            <el-row :gutter="24">
                <el-col :span="4">
                    <el-select v-model="queryInfo.type" placeholder="请选择课程类型">
                        <el-option
                            v-for="item in courseTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.openStatus" placeholder="请选择课程状态">
                        <el-option
                        v-for="item in openStatusList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-button @click="handleSearch" type="primary">搜索</el-button>
                    <el-button @click="handleAdd" type="success">新增</el-button>
                    <el-button @click="handleClear" type="warning">清空</el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList" stripe>
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column label="课程名称" width="230" prop="name"></el-table-column>
                <el-table-column label="课程类型" width="120" prop="type">
                    <template slot-scope="scope">
                        {{scope.row.type?scope.row.type==1?'1对1':'班课':''}}
                    </template>
                </el-table-column>
                <el-table-column label="单课时长(分钟)" width="125" prop="longTimeOf"></el-table-column>
                <el-table-column label="授课老师" width="140" prop="teacherId_dictText"></el-table-column>
<!--                <el-table-column label="消课系数" width="95" prop="deductTimes"></el-table-column>-->
                <el-table-column label="课程状态" width="135" prop="openStatus">
                  <template slot-scope="scope">
                    <div class="slide-switch" @click="handleSwitch(scope.$index, scope.row)">
                      <div
                        class="slider"
                        :class="{ active: scope.row.openStatus === 1 }"
                        :style="{ backgroundColor: scope.row.openStatus === 1 ? '#52c41a' : '#ff4d4f' }"
                      >
                        <span class="slider-text">
                          {{ scope.row.openStatus === 1 ? 'ON' : 'OFF' }}
                        </span>
                        <div class="slider-button"></div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="155">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" type="text" style="color:#FF9F00">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" style="color:#F53F3F">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 页数码 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNo"
                :page-sizes="[10, 15, 20, 25, 30, 35]"
                :page-size="queryInfo.pageSize"
                :total="total"
                background
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                dataList: [],
                openStatusList: [
                    { id:0, name:'未开启' },
                    { id:1, name:'已开启' },
                ],
                courseTypeList: [
                    { id:1, name:'1对1' },
                    { id:2, name:'班课' },
                ],
                queryInfo: {
                    type:null,
                    openStatus: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                total: 0,
                selectList: []
            }
        },
        mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                const { data: res } = await this.$http.post("/ea/student/course/list",this.queryInfo);
                    if(res.code == 200){
                        this.dataList = res.result.records;
                        this.total = res.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type:'error'
                        });
                    }
            },
            handleSearch() {
                this.initData();
            },
            handleAdd() {
                this.$router.push("/createCourse");
            },
            handleClear() {
                this.queryInfo.type = null;
                this.queryInfo.openStatus = null;
            },
            handleSelectionChange(val) {
                this.selectList = val;
            },
          async handleSwitch(index, row) {
              if(!row.openStatus){
                row.openStatus = 0
              }
              row.openStatus = 1 - row.openStatus;
              let idModel = {
                id:row.id
              }
            const { data: res } = await this.$http.post(`/ea/student/course/modifyOpenStatus`,idModel);
              if (res.code !== 200){
                this.$message.error(res.message);
                setTimeout(function(){
                  row.openStatus = 1 - row.openStatus;
                },200)
              }else{
                this.$message({
                  type: 'success',
                  message: '切换状态成功'
                });
              }
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleEdit(record) {
                // this.$router.push("/creatCourse");
                this.$router.push({
                    name: "createCourse",
                    params: {recordDate:record,type:'edit'}
                });
            },
            handleDelete(row) {
                this.$confirm('确认删除该课程吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteCourse(row);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 课程删除
            async deleteCourse(row){
                let idModel = {
                    id:row.id
                }
                const { data: res } = await this.$http.post(`/ea/student/course/delete`,idModel);
                if (res.code !== 200)
                return this.$message.error(res.message);
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.initData();
            },
        }
    }
</script>

<style scoped>
  .slide-switch {
    display: inline-block;
    cursor: pointer;
  }
  .slider {
    position: relative;
    width: 90px;
    height: 30px;
    border-radius: 15px;
    transition: all 0.3s ease;
  }
  .slider-button {
    position: absolute;
    width: 26px;
    height: 26px;
    background: white;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: transform 0.3s ease;
  }
  .active .slider-button {
    transform: translateX(60px); /* 滑动距离 */
  }
  .slider-text {
    position: absolute;
    width: 100%;
    text-align: center;
    line-height: 30px;
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
</style>
